import React from 'react';
import { motion } from 'framer-motion';
import ResumeFormatter from './ResumeFormatter';

const Hero = ({ guestStatus, onGuestStatusRefresh, isGuest }) => {
  return (
    <section className="pt-24 pb-8 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <div className="inline-block px-3 py-1 mb-4 text-xs font-semibold tracking-wider text-indigo-600 uppercase bg-indigo-50 rounded-full">
            Professional Formatting Tool
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold  text-slate-900 leading-tight mb-4 tracking-tight">
            Transform Resumes
            <span className="block sm:inline bg-gradient-to-r pl-3 from-indigo-600 to-violet-600 bg-clip-text text-transparent">
              In Seconds
            </span>
          </h1>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Instant professional resume formatting for recruiters. Upload, format, and download perfectly styled documents.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <ResumeFormatter
            guestStatus={guestStatus}
            onGuestStatusRefresh={onGuestStatusRefresh}
            isGuest={isGuest}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
